export default __webpack_public_path__ + "static/media/fk.79c6cee2.svg";